import { UIHeading3, UIText2 } from '@cian/ui-kit';
import { IconActionChevronRight16, IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export interface IBookedFromDeveloperContactsLayoutProps {
  onClick(): void;
  buttons?: React.ReactNode;
}

export const NewbuildingBookedFromDeveloperButton: React.FC<
  React.PropsWithChildren<IBookedFromDeveloperContactsLayoutProps>
> = ({ onClick, buttons }) => {
  return (
    <div className={styles['container']}>
      <div role="button" className={styles['message']} onClick={onClick}>
        <div className={styles['icon']}>
          <IconFunctionalLock16 />
        </div>
        <div className={styles['info']}>
          <div className={styles['title']}>
            <UIHeading3 as="h3">Квартира забронирована</UIHeading3>
          </div>
          <UIText2 color="gray60_100">Подберём похожую квартиру</UIText2>
        </div>
        <div className={styles['arrow']}>
          <IconActionChevronRight16 />
        </div>
      </div>
      {buttons && <div className={styles['buttons']}>{buttons}</div>}
    </div>
  );
};
